module.exports = __webpack_public_path__ + "img/EberleinLogo.83f2b155.png";